import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import FullViewTab from '../3modules/Config/fullViewTab/FullViewTab'
import { useEffect, useState } from 'react'
import ApiService from '../../common/ApiCalls'
import { useFormik } from 'formik'
import { tabListSchema } from '../../services/util/validation'
import useFullViewTab from '../3modules/Config/fullViewTab/useFullViewTab'

const DataViewConfiguration = () => {
  const {
    onEditMode,
    setOnEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isLoading,
    setIsLoading
  } = useConfiguration()
  const handleCancel = async () => {
    setOnEditMode(false)
    const state = await ApiService().getFullViewTabSetting()
    const { google_image_pull, missing_data_field_visibility } = state
    checkSwitch(google_image_pull)
    setMissingDataFieldVisibility(missing_data_field_visibility)
  }

  const [isSwitch, setIsSwitch] = useState()
  const [missingDataFieldVisibility, setMissingDataFieldVisibility] =
    useState(false)
  const [tabList, setTabList] = useState([])
  const arr = []

  const formik = useFormik({
    initialValues: {
      tabList: [...tabList]
    },
    validationSchema: tabListSchema,
    onSubmit: values => {
      // alert(JSON.stringify(values, null, 2))
    }
  })

  const checkSwitch = result => {
    arr.push(result)
    setIsSwitch(arr[0])
  }

  const handleSave = async () => {
    const hasError = Object.keys(formik.errors).length
    if (hasError) return
    try {
      setIsLoading(true)
      const updateTabNames = async () =>
        await ApiService().updateTabs(formik.values.tabList)
      const updateGoogleImagePull = async () =>
        await ApiService().updateAllusersStatesGoogle(isSwitch)
      const updateMissingDataFieldVisibility = async () =>
        await ApiService().updateMissingDataFieldVisibility(
          missingDataFieldVisibility
        )
      const [, , updatedTabList] = await Promise.all([
        updateGoogleImagePull(),
        updateMissingDataFieldVisibility(),
        updateTabNames()
      ])

      setTimeout(() => {
        setOnEditMode(false)
        setIsLoading(false)
        setIsSnackbarOpen({ ...isSnackbarOpen, isOpen: true })
        setTabList(updatedTabList)
      }, 500)
    } catch (e) {
      console.log(e)
    }
  }

  const { setToDefaultHandler } = useFullViewTab({
    setAdminSet: setIsSwitch,
    setMissingDataFieldVisibility,
    formik
  })

  useEffect(() => {
    const getTabs = async () => {
      try {
        const res = await ApiService().getTabs()
        await formik.setValues({ tabList: res })
        setTabList(res)
      } catch (e) {
        console.log(e)
      }
    }
    const getSettingData = async () => {
      try {
        const state = await ApiService().getFullViewTabSetting()
        const { google_image_pull, missing_data_field_visibility } = state
        setIsSwitch(google_image_pull)
        setMissingDataFieldVisibility(missing_data_field_visibility)
      } catch (e) {
        console.log(e)
      }
    }

    const getAll = async () => {
      await Promise.all([getTabs(), getSettingData()])
    }
    getAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ConfigurationWrapper
      header='Data View Configuration'
      onEditMode={onEditMode}
      setOnEditMode={setOnEditMode}
      handleCancel={handleCancel}
      isSnackbarOpen={isSnackbarOpen}
      resetToDefault={setToDefaultHandler}
      setIsSnackbarOpen={setIsSnackbarOpen}
      isLoading={isLoading}
      handleSave={handleSave}
    >
      <FullViewTab
        onEditMode={onEditMode}
        setOnEditMode={setOnEditMode}
        tabList={tabList}
        adminSet={isSwitch}
        setAdminSet={setIsSwitch}
        formik={formik}
        missingDataFieldVisibility={missingDataFieldVisibility}
        setMissingDataFieldVisibility={setMissingDataFieldVisibility}
      />
    </ConfigurationWrapper>
  )
}

export default DataViewConfiguration
